import * as loadingState from '@dragonfruit/constants/loadingState';

export const FETCH_CHANGEABLE_LIST = 'FETCH_CHANGEABLE_LIST';
export const FETCH_CHANGEABLE_LIST_SUCCESS = 'FETCH_CHANGEABLE_LIST_SUCCESS';
export const FETCH_CHANGEABLE_LIST_FAILURE = 'FETCH_CHANGEABLE_LIST_FAILURE';
export const CHECKOUT_CHANGE_PLAN = 'CHECKOUT_CHANGE_PLAN';
export const CHECKOUT_CHANGE_PLAN_SUCCESS = 'CHECKOUT_CHANGE_PLAN_SUCCESS';
export const CHECKOUT_CHANGE_PLAN_FAILURE = 'CHECKOUT_CHANGE_PLAN_FAILURE';
export const RESET_CHANGE_PLAN_CHECKOUT = 'RESET_CHANGE_PLAN_CHECKOUT';

export const fetchChangeableList = ({
  subscriptionId,
  changePlanType,
  token,
}) => ({
  type: FETCH_CHANGEABLE_LIST,
  payload: {
    subscriptionId,
    changePlanType,
    token,
  },
});
export const fetchChangeableListSuccess = ({
  changeableList,
  currentPlan,
}) => ({
  type: FETCH_CHANGEABLE_LIST_SUCCESS,
  payload: {
    changeableList,
    currentPlan,
  },
});
export const fetchChangeableListFailure = errorMessage => ({
  type: FETCH_CHANGEABLE_LIST_FAILURE,
  payload: {
    errorMessage,
  },
});

export const checkoutChangePlan = payload => ({
  type: CHECKOUT_CHANGE_PLAN,
  payload,
});

export const checkoutChangePlanSuccess = () => ({
  type: CHECKOUT_CHANGE_PLAN_SUCCESS,
});
export const checkoutChangePlanFailure = () => ({
  type: CHECKOUT_CHANGE_PLAN_FAILURE,
});
export const resetChangePlanCheckout = () => ({
  type: RESET_CHANGE_PLAN_CHECKOUT,
});

const INIT_STATE = {
  loadingStatus: loadingState.EMPTY,
  checkoutStatus: loadingState.EMPTY,
  currentPlan: {},
  changeableList: [],
  errorMessage: '',
};

// reducers
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHECKOUT_CHANGE_PLAN:
      return {
        ...state,
        checkoutStatus: loadingState.LOADING,
      };
    case CHECKOUT_CHANGE_PLAN_SUCCESS:
      return {
        ...state,
        checkoutStatus: loadingState.READY,
      };
    case CHECKOUT_CHANGE_PLAN_FAILURE:
      return {
        ...state,
        checkoutStatus: loadingState.ERROR,
      };
    case FETCH_CHANGEABLE_LIST:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case FETCH_CHANGEABLE_LIST_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
        changeableList: action.payload.changeableList,
        currentPlan: action.payload.currentPlan,
      };
    case FETCH_CHANGEABLE_LIST_FAILURE:
      return {
        ...state,
        loadingStatus: loadingState.ERROR,
        errorMessage: action.payload.errorMessage,
      };
    case RESET_CHANGE_PLAN_CHECKOUT:
      return {
        ...state,
        errorMessage: INIT_STATE.errorMessage,
        loadingStatus: INIT_STATE.loadingStatus,
        checkoutStatus: INIT_STATE.checkoutStatus,
      };
    default:
      return state;
  }
};

export default reducer;
export const getErrorMessage = state => state.changePlan.errorMessage;
export const getChangeableList = state => state.changePlan.changeableList;
export const getCurrentPlan = state => state.changePlan.currentPlan;
export const getLoadingStatus = state => state.changePlan.loadingStatus;
export const getCheckoutStatus = state => state.changePlan.checkoutStatus;



// WEBPACK FOOTER //
// ./app/redux/purchase/changePlan.js